<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">

        <!-- Prikaz ID-a ako je uključeno u var_config -->
        <!-- <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{ fc.ID.value }}
        </div> -->

        <div class="row">
            <!-- Naziv (required) -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICA.OPASNAMATERIJA.NAZIV.SINGULAR'"
                            formControlName="Naziv"
                            [ngClass]="{'is-invalid': submitted && fc.Naziv?.invalid}"
                            [MaxLength]="200">
                        </yt-input>

                        <div class="form-error" *ngIf="submitted && fc.Naziv?.invalid">
                            <span *ngFor="let validation of errorMessages.Naziv">
                                <span class="error-message" *ngIf="fc.Naziv?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Vrednost (required) -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICA.OPASNAMATERIJA.VREDNOST.SINGULAR'"
                            formControlName="Vrednost"
                            [ngClass]="{'is-invalid': submitted && fc.Vrednost?.invalid}"
                            [MaxLength]="200">
                        </yt-input>

                        <div class="form-error" *ngIf="submitted && fc.Vrednost?.invalid">
                            <span *ngFor="let validation of errorMessages.Vrednost">
                                <span class="error-message" *ngIf="fc.Vrednost?.hasError(validation.type)">
                                    <span [translate]="validation.message"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Komentar (not required) -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICA.OPASNAMATERIJA.KOMENTAR.SINGULAR'"
                            formControlName="Komentar"
                            [MaxLength]="500">
                        </yt-input>
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>
